import { useState, useEffect } from "react";
import {
  RightLayoutContainer,
  DetailFields,
  GroupTitle,
  PageTitleComp,
} from "../../styledElements";
import { Button, Row, Col, Form, Input, PageHeader } from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { HaberForm } from "../../styledElements";
import {
  useSearchParams,
  useLocation,
  Link,
  useNavigate,
} from "react-router-dom";
import { deleteRole, getRole } from "../../../Services/notifications&rolesServices";
import axios from "axios";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import ConfirmationModal from "../../../Components/Modal/ConfirmationModal";
import warning from "../../../Assets/Icons/warning.png";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
const userDetails = JSON.parse(localStorage.getItem('user-details'));

const ViewRole = (props) => {
  const source = axios.CancelToken.source();
  const [roleData, setRoleData] = useState();
  const [searchParams] = useSearchParams();
  const [actionToaster,setActionToaster] = useState({
    error: "",
    msg: "",
  });
  const [visibleToaster,setVisibleToaster] = useState(false);
  const [modalVisible,setModalVisible] = useState(false);
  const navigate = useNavigate();

  const showAccessIcon = (props = false) => {
      return props ? (
          <Iconmoon icon="correct" size={16} color="#3FBD61" />
        ) : (
            <Iconmoon icon="wrong" size={16} color="#EA4E2C" />
        );
    };

    const fetchRoleData = async() =>{
      try{
        const role = await getRole(searchParams.get("name"),source);
        setRoleData(role);
      }
      catch(e)
      {
        console.log(e);
      }
    } 

    const checkDeletable = () => {
      let predefinedRoles = ["ADMIN","SALES_COORDINATOR","DECKLE_PLANNER","PLANT_OPERATOR","SUPER_ADMIN"];
      if(userDetails.role_type == "ADMIN" && userDetails.email == roleData.created_by && !predefinedRoles.includes(roleData.name))
        return true;
      else
        return false;
    }

    const checkEditable = () => {
      if(["ADMIN","SUPER_ADMIN"].includes(userDetails.role_type) && !["ADMIN","SUPER_ADMIN"].includes(roleData.name))
        return true;
      else
        return false;
    }

    const handleDeleteRole = async() => {
      try{
        const deletedRole = await deleteRole(roleData.name);
        setModalVisible(false);
        setActionToaster({
          error:deletedRole.error,
          msg:deletedRole.msg,
        })
        showToaster();
        setTimeout(()=>navigate("/organization-setting/roles-and-permissions"),2000);
      }
      catch(e)
      {
        console.log(e);
        setActionToaster({
          error:e.data.error,
          msg:e.data.msg,
        })
      }
    }

    const showToaster = () => {
      setVisibleToaster(true);
      setTimeout(()=>setVisibleToaster(false),1500);
    }

    const modalShow = () => {
      setModalVisible(true);
    }

    useEffect(() => {
      fetchRoleData();
      return () => source.cancel();
    }, []);

  return roleData ? (
    <RightLayoutContainer>
      <PageTitleComp className="marginRightAdg">
        <PageHeader
          ghost={false}
          onBack={() => window.history.back()}
          title={roleData?.name?.replace("_"," ")}
          extra={[
            checkDeletable()?<Button
              key="1"
              className="themeBtn noBg"
              onClick={modalShow}
            >
              <Iconmoon icon="delete" size={14} color="#EA655B" />
              Delete Role
            </Button>:<></>,
            checkEditable()?<Link
              to={{
                pathname: "/organization-setting/roles-and-permissions/edit-role",
                search: `?name=${roleData.name}`,
              }}
            >
              <Button
                key="2"
                className="themeBtn"
              >
                <Iconmoon icon="edit" size={14} color="#ffffff" />
                Edit Role
              </Button>
            </Link>:<></>
          ]}
        ></PageHeader>
      </PageTitleComp>
      <DetailFields>
        <HaberForm>
          <div className="groupDetailWrap">
            <Form
              name="basic"
              autoComplete="off"
              className="haberLogin"
            >
              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>General Details</h2>
                    <p>Enter general details of the role</p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign" gutter={[0,30]}>
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Role Name</label>
                        <p>Enter the name you want to assign to the role</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="roleName"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            }
                          ]}
                          className=""
                        >
                          <Input placeholder="Enter role name" defaultValue={roleData?.name?.replace("_"," ")} disabled/>
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row
                gutter={[24, 24]}
                className="groupForm"
                style={{ borderBottom: "0px" }}
              >
                <Col span={8}>
                  <GroupTitle style={{ marginTop: "10px" }}>
                    <h2>Access Control</h2>
                    <p>This user will have access to selected modules</p>
                  </GroupTitle>
                </Col>
              </Row>
              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Configurations</h2>
                    <p>User access to configurations can be controlled here</p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign titleVCenter paddingTB">
                    <Col span={24}>
                      <div className="boxFieldTitle ant-col-8">
                        <label>Global Settings</label>
                      </div>
                      <div className="boxFormType reverseCheckbox">
                        <div className="imageShowed">
                          <label>
                            <span>
                              {showAccessIcon(
                                roleData.roles.global_settings.view
                              )}
                            </span>{" "}
                            <span>View</span>
                          </label>
                          <label>
                            <span>
                              {showAccessIcon(
                                roleData.roles.global_settings.edit
                              )}
                            </span>{" "}
                            <span>Edit</span>
                          </label>
                        </div>
                      </div>
                    </Col>
                    <Col span={24}>
                      <div className="boxFieldTitle ant-col-8">
                        <label>Machine Records</label>
                      </div>
                      <div className="boxFormType reverseCheckbox">
                        <div className="imageShowed">
                          <label>
                            <span>
                              {showAccessIcon(
                                roleData.roles.machine_records.view
                              )}
                            </span>{" "}
                            <span>View</span>
                          </label>
                          <label>
                            <span>
                              {showAccessIcon(
                                roleData.roles.machine_records.edit
                              )}
                            </span>{" "}
                            <span>Edit</span>
                          </label>
                        </div>
                      </div>
                    </Col>
                    <Col span={24}>
                      <div className="boxFieldTitle ant-col-8">
                        <label>Product Records</label>
                      </div>
                      <div className="boxFormType reverseCheckbox">
                        <div className="imageShowed">
                          <label>
                            <span>
                              {showAccessIcon(
                                roleData.roles.product_records.view
                              )}
                            </span>{" "}
                            <span>View</span>
                          </label>
                          <label>
                            <span>
                              {showAccessIcon(
                                roleData.roles.product_records.edit
                              )}
                            </span>{" "}
                            <span>Edit</span>
                          </label>
                        </div>
                      </div>
                    </Col>
                    <Col span={24}>
                      <div className="boxFieldTitle ant-col-8">
                        <label>Customer Records</label>
                      </div>
                      <div className="boxFormType reverseCheckbox">
                        <div className="imageShowed">
                          <label>
                            <span>
                              {showAccessIcon(
                                roleData.roles.customer_records.view
                              )}
                            </span>{" "}
                            <span>View</span>
                          </label>
                          <label>
                            <span>
                              {showAccessIcon(
                                roleData.roles.customer_records.edit
                              )}
                            </span>{" "}
                            <span>Edit</span>
                          </label>
                        </div>
                      </div>
                    </Col>
                    <Col span={24}>
                      <div className="boxFieldTitle ant-col-8">
                        <label>Workflow Settings</label>
                      </div>
                      <div className="boxFormType reverseCheckbox">
                        <div className="imageShowed">
                          <label>
                            <span>
                              {showAccessIcon(
                                roleData.roles.workflow_settings.view
                              )}
                            </span>{" "}
                            <span>View</span>
                          </label>
                          <label>
                            <span>
                              {showAccessIcon(
                                roleData.roles.workflow_settings.edit
                              )}
                            </span>{" "}
                            <span>Edit</span>
                          </label>
                        </div>
                      </div>
                    </Col>
                    <Col span={24}>
                      <div className="boxFieldTitle ant-col-8">
                        <label>Advanced Settings</label>
                      </div>
                      <div className="boxFormType reverseCheckbox">
                        <div className="imageShowed">
                          <label>
                            <span>
                              {showAccessIcon(
                                roleData.roles.advanced_settings.view
                              )}
                            </span>{" "}
                            <span>View</span>
                          </label>
                          <label>
                            <span>
                              {showAccessIcon(
                                roleData.roles.advanced_settings.edit
                              )}
                            </span>{" "}
                            <span>Edit</span>
                          </label>
                        </div>
                      </div>
                    </Col>
                    <Col span={24}>
                      <div className="boxFieldTitle ant-col-8">
                        <label>Packaging Types</label>
                      </div>
                      <div className="boxFormType reverseCheckbox">
                        <div className="imageShowed">
                          <label>
                            <span>
                              {showAccessIcon(
                                roleData.roles.packaging_config.view
                              )}
                            </span>{" "}
                            <span>View</span>
                          </label>
                          <label>
                            <span>
                              {showAccessIcon(
                                roleData.roles.packaging_config.edit
                              )}
                            </span>{" "}
                            <span>Edit</span>
                          </label>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Order Management</h2>
                    <p>
                      User access to order management can be controlled here
                    </p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign titleVCenter paddingTB">
                    <Col span={24}>
                      <div className="boxFieldTitle ant-col-8">
                        <label>Order Records</label>
                      </div>
                      <div className="boxFormType reverseCheckbox">
                        <div className="imageShowed">
                          <label>
                            <span>
                              {showAccessIcon(
                                roleData.roles.order_records.view_own
                              )}
                            </span>{" "}
                            <span>View Own</span>
                          </label>
                          <label>
                            <span>
                              {showAccessIcon(
                                roleData.roles.order_records.view_all
                              )}
                            </span>{" "}
                            <span>View All</span>
                          </label>
                          <label>
                            <span>
                              {showAccessIcon(
                                roleData.roles.order_records.edit_own
                              )}
                            </span>{" "}
                            <span>Edit Own</span>
                          </label>
                          <label>
                            <span>
                              {showAccessIcon(
                                roleData.roles.order_records.edit_all
                              )}
                            </span>{" "}
                            <span>Edit All</span>
                          </label>
                        </div>
                      </div>
                    </Col>
                    <Col span={24}>
                      <div className="boxFieldTitle ant-col-8">
                        <label>Approve Orders</label>
                      </div>
                      <div className="boxFormType reverseCheckbox">
                        <div className="imageShowed">
                          <label>
                            <span>
                              {showAccessIcon(
                                roleData.roles.approve_orders.edit
                              )}
                            </span>{" "}
                            <span>Approve</span>
                          </label>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Deckle Management</h2>
                    <p>
                      User access to deckle management can be controlled here
                    </p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign titleVCenter paddingTB">
                    <Col span={24}>
                      <div className="boxFieldTitle ant-col-8">
                        <label>Job Cards</label>
                      </div>
                      <div className="boxFormType reverseCheckbox">
                        <div className="imageShowed">
                          <label>
                            <span>
                              {showAccessIcon(roleData.roles.job_cards.view)}
                            </span>{" "}
                            <span>View</span>
                          </label>
                          <label>
                            <span>
                              {showAccessIcon(roleData.roles.job_cards.edit)}
                            </span>{" "}
                            <span>Edit</span>
                          </label>
                        </div>
                      </div>
                    </Col>
                    <Col span={24}>
                      <div className="boxFieldTitle ant-col-8">
                        <label>Approve Job Cards</label>
                      </div>
                      <div className="boxFormType reverseCheckbox">
                        <div className="imageShowed">
                          <label>
                            <span>
                              {showAccessIcon(
                                roleData.roles.approve_jobcards.edit
                              )}
                            </span>{" "}
                            <span>Approve</span>
                          </label>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Organization Settings</h2>
                    <p>
                      User access to organization settings can be controlled
                      here
                    </p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign titleVCenter paddingTB">
                    <Col span={24}>
                      <div className="boxFieldTitle ant-col-8">
                        <label>Company Profile</label>
                      </div>
                      <div className="boxFormType reverseCheckbox">
                        <div className="imageShowed">
                          <label>
                            <span>
                              {showAccessIcon(
                                roleData.roles.company_profile.view
                              )}
                            </span>{" "}
                            <span>View</span>
                          </label>
                          <label>
                            <span>
                              {showAccessIcon(
                                roleData.roles.company_profile.edit
                              )}
                            </span>{" "}
                            <span>Edit</span>
                          </label>
                        </div>
                      </div>
                    </Col>
                    <Col span={24}>
                      <div className="boxFieldTitle ant-col-8">
                        <label>User Management</label>
                      </div>
                      <div className="boxFormType reverseCheckbox">
                        <div className="imageShowed">
                          <label>
                            <span>
                              {showAccessIcon(
                                roleData.roles.user_management.view
                              )}
                            </span>{" "}
                            <span>View</span>
                          </label>
                          <label>
                            <span>
                              {showAccessIcon(
                                roleData.roles.user_management.edit
                              )}
                            </span>{" "}
                            <span>Edit</span>
                          </label>
                        </div>
                      </div>
                    </Col>
                    <Col span={24}>
                      <div className="boxFieldTitle ant-col-8">
                        <label>Plan Details and Billing</label>
                      </div>
                      <div className="boxFormType reverseCheckbox">
                        <div className="imageShowed">
                          <label>
                            <span>
                              {showAccessIcon(
                                roleData.roles.plan_details_and_billing.view
                              )}
                            </span>{" "}
                            <span>View</span>
                          </label>
                          <label>
                            <span>
                              {showAccessIcon(
                                roleData.roles.plan_details_and_billing.edit
                              )}
                            </span>{" "}
                            <span>Edit</span>
                          </label>
                        </div>
                      </div>
                    </Col>
                                        <Col span={24}>
                      <div className="boxFieldTitle ant-col-8">
                        <label>Notifications</label>
                      </div>
                      <div className="boxFormType reverseCheckbox">
                        <div className="imageShowed">
                          <label>
                            <span>
                              {showAccessIcon(
                                roleData.roles.notifications.view
                              )}
                            </span>{" "}
                            <span>View</span>
                          </label>
                          <label>
                            <span>
                              {showAccessIcon(
                                roleData.roles.notifications.edit
                              )}
                            </span>{" "}
                            <span>Edit</span>
                          </label>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Production Planning</h2>
                    <p>
                      User access to production planning can be controlled here
                    </p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign titleVCenter paddingTB">
                    <Col span={24}>
                      <div className="boxFieldTitle ant-col-8">
                        <label>Job Cards</label>
                      </div>
                      <div className="boxFormType reverseCheckbox">
                        <div className="imageShowed">
                          <label>
                            <span>
                              {showAccessIcon(
                                roleData.roles.production?.job_cards?.view
                              )}
                            </span>{" "}
                            <span>View</span>
                          </label>
                          <label>
                            <span>
                              {showAccessIcon(
                                roleData.roles.production?.job_cards?.edit
                              )}
                            </span>{" "}
                            <span>Edit</span>
                          </label>
                        </div>
                      </div>
                    </Col>
                    <Col span={24}>
                      <div className="boxFieldTitle ant-col-8">
                        <label>Jumbo Reels</label>
                      </div>
                      <div className="boxFormType reverseCheckbox">
                        <div className="imageShowed">
                          <label>
                            <span>
                              {showAccessIcon(
                                roleData.roles.production?.jumbo_reels?.view
                              )}
                            </span>{" "}
                            <span>View</span>
                          </label>
                          <label>
                            <span>
                              {showAccessIcon(
                                roleData.roles.production?.jumbo_reels?.edit
                              )}
                            </span>{" "}
                            <span>Edit</span>
                          </label>
                        </div>
                      </div>
                    </Col>
                    <Col span={24}>
                      <div className="boxFieldTitle ant-col-8">
                        <label>Production Details</label>
                      </div>
                      <div className="boxFormType reverseCheckbox">
                        <div className="imageShowed">
                          <label>
                            <span>
                              {showAccessIcon(
                                roleData.roles.production?.prod_details?.view
                              )}
                            </span>{" "}
                            <span>View</span>
                          </label>
                          <label>
                            <span>
                              {showAccessIcon(
                                roleData.roles.production?.prod_details?.edit
                              )}
                            </span>{" "}
                            <span>Edit</span>
                          </label>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Stock Management</h2>
                    <p>
                      User access to stock management can be controlled here
                    </p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign titleVCenter paddingTB">
                    <Col span={24}>
                      <div className="boxFieldTitle ant-col-8">
                        <label>Stock Records</label>
                      </div>
                      <div className="boxFormType reverseCheckbox">
                        <div className="imageShowed">
                          <label>
                            <span>
                              {showAccessIcon(
                                roleData.roles.inventory?.stocks?.view
                              )}
                            </span>{" "}
                            <span>View</span>
                          </label>
                          <label>
                            <span>
                              {showAccessIcon(
                                roleData.roles.inventory?.stocks?.edit
                              )}
                            </span>{" "}
                            <span>Edit</span>
                          </label>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              
            </Form>
          </div>
        </HaberForm>
      </DetailFields>
      <ConfirmationModal
          visible={modalVisible}
          icon={warning}
          confirmAction={()=>handleDeleteRole()}
          cancelAction={()=>setModalVisible(false)}
      >
        <span>Are you sure?</span>
        <p>
          Once deleted the role cannot be recovered. Do you want to continue?
        </p>
      </ConfirmationModal>
      {visibleToaster && !actionToaster.error && (
        <AlertContainer
          color="green toaster"
          icon={alertGreen}
          msg={actionToaster.msg}
        />
      )}
      {visibleToaster && actionToaster.error && (
        <AlertContainer
          color="red toaster"
          icon={alertRed}
          msg={actionToaster.msg}
        />
      )}
    </RightLayoutContainer>
  ) : null;
};

export default ViewRole;
